import Vuex from 'vuex';

const store = new Vuex.Store({
	state: {
		user: false,
		search_config: false,
		facet_info: false,
		search_params: {},
		filter_items: [],
	},
	getters: {
		getRawUser: state => {
			return state.user;
		},
		getUser: state => {
			if (state.user) {
				return JSON.parse(atob(state.user));
			}
			return false;
		},
		getSearchConfig(state) {
			return state.search_config;
		},
		getFacetInfo(state) {
			return state.facet_info;
		},
		getSearchParams(state) {
			return state.search_params;
		},
		getFilterItems(state) {
			return state.filter_items;
		}
	},
	mutations: {
		updateRawUser(state, user) {
			if (window.location.href.includes("2021.escapethecity.org")) {
				console.log("Updating RAW User:","..."+user.substr(-10));
				console.log("Updating User:",JSON.parse(atob(user)));
			}
			state.user = user;
		},
		updateUser(state, user) {
			if (window.location.href.includes("2021.escapethecity.org")) {
				console.log("Updating User:",user);
			}
			state.user = btoa(JSON.stringify(user));
		},
		updateSearchConfig(state, payload) {
			//console.log("updating search config in vuex",payload);
			state.search_config = payload;
		},
		updateFacetInfo(state, payload) {
			//console.log("updating facet info in vuex",payload);
			state.facet_info = payload;
		},
		updateFacetInfoItem(state, payload) {
			//Vue.set(state.facet_info, payload.index, payload.item) // Object Setting
			state.facet_info[payload.index] = payload.item; // Vue 3 Syntax
		},
		updateSearchParams(state, payload) {
			//console.log("updating search_params in vuex",payload);
			state.search_params = payload;
		},
		updateFilterItems(state, payload) {
			//console.log("updating filter_items in vuex",payload);
			state.filter_items = payload;
		}
	}
});

export default store;
